/**
 * Get the home text content from API
 * @param {object} state - The vuex state object
 * @return {object[]} A array of content
 */
export const getHomeTextContent = (state) => {
  return Array.isArray(state.contentObject) ? state.contentObject.filter(el => el.type === "2") : null
};


/**
 * Get the home events content from API
 * @param {object} state - The vuex state object
 * @return {object[]} A array of events content
 */
export const getHomeEventsContent = (state) => {
  return Array.isArray(state.contentObject) ? state.contentObject.filter(el => el.type === "1") : null
};
